import { connect } from "react-redux";
import { useParams } from "react-router";
import { useEffect, useState } from "react";

import { Container } from "@material-ui/core";
import RecordView from "./record-view";
import { toSmallQuantityFields } from "./to-haulage-record-fields";
import smallQuantityTicketService from "../../services/smallQuantityTicketService";
import { SmallQuantityHaulageTicketPayload } from "../../interface/api/SmallQuantityHaulageTicketPayload";

// Reached by the haul-record QR on the top and bottom tabs of the printed Small Quantity
// ticket. Public, like the Main Pit /haulage-record/:id.
const SmallQuantityHaulageRecordView = ({}) => {
  const { id }: any = useParams();
  const [payload, setPayload] = useState<SmallQuantityHaulageTicketPayload>();

  useEffect(() => {
    smallQuantityTicketService.getHaulageRecord(id).then((response) => {
      if (response.ok) {
        setPayload(response.data as SmallQuantityHaulageTicketPayload);
      }
    });
  }, []);

  return (
    <Container maxWidth="sm">
      <>{payload && <RecordView fields={toSmallQuantityFields(payload)} />}</>
    </Container>
  );
};

export default connect()(SmallQuantityHaulageRecordView);
